export const GET_PAYFAC_COMMISSIONS_BY_PRICING_TABLE_GUID_AND_MERCHANT_GUID ="GET_PAYFAC_COMMISSIONS_BY_PRICING_TABLE_GUID_AND_MERCHANT_GUID"
export const GET_PAYFAC_COMMISSIONS_BY_PRICING_TABLE_GUID_AND_MERCHANT_GUID_SUCCESS="GET_PAYFAC_COMMISSIONS_BY_PRICING_TABLE_GUID_AND_MERCHANT_GUID_SUCCESS"
export const GET_PAYFAC_COMMISSIONS_BY_PRICING_TABLE_GUID_AND_MERCHANT_GUID_FAIL = "GET_PAYFAC_COMMISSIONS_BY_PRICING_TABLE_GUID_AND_MERCHANT_GUID_FAIL"

export const INSERT_MERCHANT_COMMISSIONS ="INSERT_MERCHANT_COMMISSIONS"
export const INSERT_MERCHANT_COMMISSIONS_SUCCESS="INSERT_MERCHANT_COMMISSIONS_SUCCESS"
export const INSERT_MERCHANT_COMMISSIONS_FAIL = "INSERT_MERCHANT_COMMISSIONS_FAIL"


export const UPDATE_MERCHANT_COMMISSIONS ="UPDATE_MERCHANT_COMMISSIONS"
export const UPDATE_MERCHANT_COMMISSIONS_SUCCESS="UPDATE_MERCHANT_COMMISSIONS_SUCCESS"
export const UPDATE_MERCHANT_COMMISSIONS_FAIL = "UPDATE_MERCHANT_COMMISSIONS_FAIL"


export const MERCHANT_COMMISSION_LIST_API_ERROR = "API_ERROR"

